'use client';

import React, { useEffect, useState } from 'react';

interface DynamicLogoProps {
    svgUrl: string;
    color?: string;
    alt?: string;
}

const DynamicLogo: React.FC<DynamicLogoProps> = ({ svgUrl, color = '#23201F', alt = 'Logo' }) => {
    const [svgContent, setSvgContent] = useState<string | null>(null);

    useEffect(() => {
        const fetchSvg = async () => {
            try {
                const res = await fetch(svgUrl);
                const text = await res.text();

                // Replace all fill colors with the provided one
                const coloredSvg = text.replace(/fill="[^"]*"/g, `fill="${color}"`);
                setSvgContent(coloredSvg);
            } catch (error) {
                console.error('Failed to fetch SVG:', error);
            }
        };

        if (svgUrl.endsWith('.svg')) {
            fetchSvg();
        }
    }, [svgUrl, color]);

    return (
      <>
        {svgContent ? (
          <div dangerouslySetInnerHTML={{ __html: svgContent }} aria-label={alt} />
        ) : (
          <>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={svgUrl} alt={alt} className="object-cover block top-0 left-0" />
          </>
        )}
      </>
    );
};

export default DynamicLogo;
